import { Card, Col, Row, Typography } from "antd";
import colors from "constants/colors";
import { useEffect, useState } from "react";
import { RegisteredStudentData } from "../AdminSingleEventPage";
import { EventProgress } from "./Charts";

const { Title, Text } = Typography;

interface Props {
  registeredStudents: RegisteredStudentData[];
  waitlist: RegisteredStudentData[];
  seats: number;
  waitingListSize: number;
  noShows: number;
}

const EventStats: React.FC<Props> = ({ seats, waitingListSize, waitlist, registeredStudents, noShows }) => {
  const [registeredPercentage, setRegisteredPercentage] = useState<number>(0);
  const [waitlistPercentage, setWaitlistPercentage] = useState<number>(0);
  const [attendancePercentage, setAttendancePercentage] = useState<number>(0);
  const [noshowPercentage, setNoshowPercentage] = useState<number>(0);
  const [indokPercentage, setIndokPercentage] = useState<number>(0);

  useEffect(() => {
    if (seats > 0) setRegisteredPercentage(registeredStudents.length / seats);
    if (waitingListSize > 0) setWaitlistPercentage(waitlist.length / waitingListSize);
    if (registeredStudents.length > 0)
      setIndokPercentage(registeredStudents.filter(s => s.study_programme_id === 1).length / registeredStudents.length);
    if (registeredStudents.length > 0)
      setAttendancePercentage(registeredStudents.filter(s => s.time_attended).length / registeredStudents.length);
    if (registeredStudents.length > 0) setNoshowPercentage(noShows / registeredStudents.length);
  }, [registeredStudents, seats, waitingListSize, waitlist, noShows]);

  return (
    <>
      <Row
        gutter={[16, 16]}
        style={{ width: "calc(100% + 16px)", marginTop: "16px", display: "flex", alignItems: "stretch" }}
      >
        <Col lg={4} md={8} sm={12} xs={24}>
          <Card style={{ height: "100%" }}>
            <Title style={{ color: "var(--bindeleddet-color)", margin: "0" }}>{seats}</Title>
            <Text style={{ color: colors.secondary }}>PLASSER</Text>
            <EventProgress percent={1} color={colors.gray} />
            <Text style={{ color: "var(--bindeleddet-color)", fontSize: "0.8em" }}>
              {waitingListSize} ventelisteplasser
            </Text>
          </Card>
        </Col>
        <Col lg={4} md={8} sm={12} xs={24}>
          <Card style={{ height: "100%" }}>
            <Title style={{ color: "var(--bindeleddet-color)", margin: "0" }}>{registeredStudents.length}</Title>
            <Text style={{ color: colors.secondary }}>PÅMELDTE</Text>
            <EventProgress percent={registeredPercentage} color={colors.primary} />
            <Text style={{ color: "var(--bindeleddet-color)", fontSize: "0.9em" }}>
              {Math.round(registeredPercentage * 100)}% av plasser
            </Text>
          </Card>
        </Col>
        <Col lg={4} md={8} sm={12} xs={24}>
          <Card style={{ height: "100%" }}>
            <Title style={{ color: "var(--bindeleddet-color)", margin: "0" }}>{waitlist.length}</Title>
            <Text style={{ color: colors.secondary }}>PÅ VENTELISTE</Text>
            <EventProgress percent={waitlistPercentage} color={colors.primary} />
            <Text style={{ color: "var(--bindeleddet-color)", fontSize: "0.9em" }}>
              {Math.round(waitlistPercentage * 100)}% av venteliste
            </Text>
          </Card>
        </Col>
        <Col lg={4} md={8} sm={12} xs={24}>
          <Card style={{ height: "100%" }}>
            <Title style={{ color: "var(--bindeleddet-color)", margin: "0" }}>
              {registeredStudents.filter(s => s.study_programme_id === 1).length}
            </Title>
            <Text style={{ color: colors.secondary }}>INDØKERE</Text>
            <EventProgress percent={indokPercentage} color={colors.primary} />
            <Text style={{ color: "var(--bindeleddet-color)", fontSize: "0.9em" }}>
              {Math.round(indokPercentage * 100)}% av påmeldte
            </Text>
          </Card>
        </Col>
        <Col lg={4} md={8} sm={12} xs={24}>
          <Card style={{ height: "100%" }}>
            <Title style={{ color: "var(--bindeleddet-color)", margin: "0" }}>
              {registeredStudents.filter(s => s.time_attended).length}
            </Title>
            <Text style={{ color: colors.secondary }}>OPPMØTTE</Text>
            <EventProgress percent={attendancePercentage} color={colors.primary} />
            <Text style={{ color: "var(--bindeleddet-color)", fontSize: "0.9em" }}>
              {Math.round(attendancePercentage * 100)}% av påmeldte
            </Text>
          </Card>
        </Col>
        <Col lg={4} md={8} sm={12} xs={24}>
          <Card style={{ height: "100%" }}>
            <Title type="danger" style={{ margin: "0" }}>
              {noShows}
            </Title>
            <Text style={{ color: colors.secondary }}>NOSHOWS</Text>
            <EventProgress percent={noshowPercentage} color="#ff4d4f" />
            <Text style={{ color: "var(--bindeleddet-color)", fontSize: "0.9em" }}>
              {Math.round(noshowPercentage * 100)}% av påmeldte
            </Text>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default EventStats;
